module.exports = __webpack_public_path__ + "img/power-swiper-item (2).e1926054.png";